import * as Device from '../modules/_device';
import { isset } from '../func/_general';

const CSS__EFFECT = 'effect';

const SEL__HEADER = 'header';
const SEL__HERO = '#hero';

const BRAND_LOGO = 'svg#logo_1a_berlin_zimmer';
const BRAND_LOGO__TARGET_HEADER = 'header .brand .brand__logo';
const BRAND_LOGO__TARGET_HERO = '#hero #brandLogo';

const STATUS__PINNED = 'pinned';

let lastKnownScrollY = 0;
let currentScrollY = 0;
let ticking = false;

let limit = 0;

let classes = {
	pinned: 'pinned',
	unpinned: 'unpinned'
};

function toggle__on_scroll(doNotHideAtMobile,initial) {
	
	var toggle = true;
	
	if(!isset(doNotHideAtMobile)) { doNotHideAtMobile = false; }
	if(!isset(initial)) { initial = false; }
	
	if(Device.is__mobile()) {
		if(doNotHideAtMobile) {
			toggle = false;
		}
	}
	else {
		if(!$('#hero').hasClass('animated')) {
			toggle = false;
		}
	}
	
	if(toggle) {
		currentScrollY = window.pageYOffset;
		requestTick();
	} else {
		if(Device.is__mobile() && initial) {
			pin();
		}
	}
	
	
	
}


function requestTick() {
	if(limit === 0) {
		limit = $(SEL__HERO).outerHeight(true)
	}
	if (!ticking) {
	  requestAnimationFrame(update);
	}
	ticking = true;
}

function update() {
	if(currentScrollY >= limit) {
		if (currentScrollY < lastKnownScrollY) {
			pin();
		} else if (currentScrollY > lastKnownScrollY) {
			unpin();
		}
	} else {
		unpin();
	}
	lastKnownScrollY = currentScrollY;
	ticking = false;
}

function pin() {
	if($(SEL__HEADER).hasClass(classes.unpinned) || (!$(SEL__HEADER).hasClass(classes.unpinned) && !$(SEL__HEADER).hasClass(classes.pinned))) {
		$(SEL__HEADER).removeClass(classes.unpinned).addClass(classes.pinned);
		toggle__position_navigation('initial');
		
		if($(BRAND_LOGO__TARGET_HEADER + ' svg').length < 1) {
			$(BRAND_LOGO__TARGET_HEADER).prepend($(BRAND_LOGO__TARGET_HERO + ' svg').clone());
		}
		
	}
}
function unpin() {
	if($(SEL__HEADER).hasClass(classes.pinned) || !$(SEL__HEADER).hasClass(classes.unpinned)) {
		$(SEL__HEADER).removeClass(classes.pinned).addClass(classes.unpinned);
		toggle__position_navigation('target');
	}
}



function toggle__header_on_scroll2() {
	
	var brandLogo = 'svg#logo_1a_berlin_zimmer';

	var target_brandLogo__header = 'header .brand .brand__logo';
	var target_brandLogo__hero = '#hero #brandLogo';

	var scrollPos = $(document).scrollTop();

	console.log(scrollPos);

	if(scrollPos > (Device.get__dimension(Device.ACTION__GET_HEIGHT_VIEWPORT) - parseInt($('header').height())) / 2) {
		$(target_brandLogo__header).prepend($(target_brandLogo__hero+' '+brandLogo));
		toggle__position_navigation('initial');
	} else {
		$(target_brandLogo__hero).prepend($(target_brandLogo__header+' '+brandLogo));
		toggle__position_navigation('target');
	}

	if(scrollPos > Device.get__dimension(Device.ACTION__GET_HEIGHT_VIEWPORT) - parseInt($('header').height()) ) {
		$('header').addClass(STATUS__PINNED);
		toggle__class_navigation_items('add');
	} else {
		$('header').removeClass(STATUS__PINNED);
		toggle__class_navigation_items('remove');
	}

};


function toggle__class_navigation_items(action) {
	if($('header nav').attr('data-effect')) {
		var headerNavItemClasses = CSS__EFFECT;
		headerNavItemClasses = headerNavItemClasses.concat(
			' ',
			CSS__EFFECT,
			'--',
			$('header nav').attr('data-effect')
		);
		if(action === 'add') {
			$('header nav a').addClass(headerNavItemClasses);
		} else {
			$('header nav a').removeClass(headerNavItemClasses);
		}
	}
};


function toggle__position_navigation($state) {
	
	var selector__initial = '.header__nav';
	var target  = $(selector__initial).attr('data-move');
	
	if(isset(target)) {
		var selector__target = '.'+target+'__nav';

		switch($state) {
		case 'initial':
			$(selector__target).children('nav').appendTo(selector__initial);
			break;
		case 'target':
			$(selector__initial).children('nav').appendTo(selector__target);
			break;
		} 
	}
	
}


export {
	pin,
	toggle__on_scroll,
	unpin
};